import { componentName, UploadFileClass } from './UploadFileClass';
import '@descope-ui/descope-button';

customElements.define(componentName, UploadFileClass);

export { UploadFileClass, componentName };
